// Detect package manager để cài binary hệ thống (gh CLI). Order matters:
// brew (macOS preferred) → winget (Windows) → apt/dnf/pacman (Linux distros).
// Returns null nếu không tìm được PM nào — caller phải fail-fast.
import { spawnSync } from "node:child_process";
import { detectHostPlatform } from "./detect-host-platform.js";

export type PackageManager = "brew" | "apt" | "dnf" | "pacman" | "winget";

// Probe binary có trong PATH không. Dùng `command -v` (POSIX) hoặc `where` (Win).
function hasBinary(name: string): boolean {
  const platform = detectHostPlatform();
  const probe = platform === "win32" ? "where" : "command";
  const args = platform === "win32" ? [name] : ["-v", name];
  // spawnSync với shell=true để `command -v` (builtin) hoạt động.
  const r = spawnSync(probe, args, {
    shell: platform !== "win32",
    stdio: "ignore",
  });
  return r.status === 0;
}

// Trả về PM đầu tiên có sẵn theo thứ tự ưu tiên phù hợp với OS.
export function detectPackageManager(): PackageManager | null {
  const platform = detectHostPlatform();
  const candidates: PackageManager[] =
    platform === "darwin"
      ? ["brew"]
      : platform === "win32"
        ? ["winget"]
        : platform === "linux"
          ? ["apt", "dnf", "pacman"]
          : [];
  for (const pm of candidates) {
    if (hasBinary(pm)) return pm;
  }
  return null;
}
